<template>
  <TWModal
    :title="$t('signingSequence.ui.title_edit')"
    :loading="false"
    :show="show"
    :allow-outside-click-to-close="true"
    @close="handleClose"
    class="ui-signingSequence-modals-EditModal">
    <template v-slot:content>
      <form>
        <SigningSequenceSelector
          :showTitle="false"
          :current-selection="value"
          @selectionUpdated="setSelection"
          id="edit_signing_sequence"
          class="p-base"
        />
      </form>
    </template>

    <template v-slot:controls>
      <BaseButton
        @click.native="handleClose"
        variant="invisible"
        data-ec="signing_sequence"
        data-et="edit_btn_cancel"
        data-test="button-cancel"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>

      <BaseButton
        @click.native="handleSave"
        data-ec="signing_sequence"
        data-et="edit_btn_save"
        data-test="button-save"
      >
        {{ $t('functional.update') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import SigningSequenceSelector from '@/components/ui/signingSequence/SigningSequenceSelector.vue';

export default {
  name: 'EditModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    currentSelection: {
      type: String,
      required: true,
      validator(value) {
        return ['parallel', 'sequential'].includes(value);
      },
    },
  },
  components: {
    BaseButton,
    TWModal,
    SigningSequenceSelector,
  },
  data() {
    return {
      value: this.currentSelection,
    };
  },
  watch: {
    currentSelection(newValue) {
      this.value = newValue;
    },
  },
  methods: {
    setSelection(value) {
      this.value = value;
    },
    handleClose() {
      this.resetComponent();
      this.$emit('close');
    },
    handleSave() {
      this.$emit('selectionSaved', this.value);
      this.handleClose();
    },
    resetComponent() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>
